import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { RegistrationProductInformationModule } from '../registration-product-information/registration-product-information.module';

import { RegistrationProductInformationListComponent } from './registration-product-information-list.component';

@NgModule({
	imports: [
		CommonModule,
		RegistrationProductInformationModule,
	],
	declarations: [RegistrationProductInformationListComponent],
	exports: [RegistrationProductInformationListComponent],
})
export class RegistrationProductInformationListModule { }
